const linkPattern = /(?:([A-Za-z]{3,9}:\/\/)((?:(?:[\w\d-_]+\.?)+\.[A-Za-z]{2,3})|(?:(?:\d+\.?)+)|(?:\[(?:(?:[\w\d]{1,4}:?)+)\]))(?::[\d]{1,5})?(?:(?:\/[\w\d-._%]*)*(?:\.[\w]{2,4})?)(?:\?(?:&?[\w\d\_\[\]]+=[^&\s]*)*)?(#(?:[\w\d-_]*\/?)*)?)/i;

export default linkPattern;